import "./Tech.css";
import React from "react";
import { Link } from "react-router-dom";
import { techs } from "../data/tech";

const Tech = () => {
  return (
    <div className="container boxes">
      <div className="backhome__link">
        <Link to="/">Back To Home</Link>
      </div>
      {techs?.map((tech) => (
        <div key={tech.id} className="tech__box">
          <img src={tech.imageSource} alt="" />
          <p>{tech.techName}</p>
        </div>
      ))}
    </div>
  );
};

export default Tech;
